import { SkeletonLoader } from "@kanda-libs/ks-design-library";
import { FunctionComponent } from "react";

export interface GoogleSignInButtonProps {
  isLoading?: boolean;
  socialDisabled?: boolean;
  onSignIn?: () => void;
}

export const GoogleSignInButton: FunctionComponent<GoogleSignInButtonProps> = ({
  isLoading = false,
  socialDisabled = false,
  onSignIn = () => {},
}) => (
  <SkeletonLoader
    isLoading={isLoading}
    width="100%"
    height={44}
    wrapperClassName="w-full"
    afterLoading={
      <button
        className="flex flex-row w-full h-12 p-3 mb-4 rounded font-roboto social-shadow md:mb-0 md:mr-4"
        type="button"
        disabled={socialDisabled}
        onClick={onSignIn}
      >
        <img
          width={24}
          height={24}
          src="/g-logo.png"
          alt="g-logo"
          className="w-6 h-6 mr-3"
        />
        <p className="my-auto text-14-22 whitespace-nowrap">
          Sign in with Google
        </p>
      </button>
    }
  />
);
